export default __webpack_public_path__ + "ch-adventure.icon-f575ef8a06e9e3ea5f96431c34cc6e23.png";